const authnType = {
  //
  SET_AUTHN_STATE: "SET_AUTHN_STATE",
  SET_AUTHN_IDP: "SET_AUTHN_IDP",
};

export default authnType;
